import { EnvironmentProviders } from '@angular/core';

import {
  MedicalShopOrganizationSettingsPermissions,
  MedicalShopPermissions,
  createMedicalShopOrganizationSettingsPlugin,
} from '@mp/medical-shop-2/core';
import { provideModuleInfo } from '@mp/shared/util';
import { provideModuleOrganizationSettings, provideModulePermissions } from '@mpk/shared/data-access';

const moduleName = 'MedicalShop';

export function provideMedicalShopFeature(): EnvironmentProviders[] {
  return [
    provideModuleInfo(moduleName, {
      displayName: 'Medical Shop',
    }),
    provideModulePermissions(moduleName, MedicalShopPermissions, MedicalShopOrganizationSettingsPermissions),
    // Gruppe wie in Belegen und Belegsteuerung: der Eintrag heißt "MarketPlace" und steht neben
    // "Anforderungen" und "Belegsteuerung" unter den Moduleinstellungen.
    provideModuleOrganizationSettings('Moduleinstellungen', createMedicalShopOrganizationSettingsPlugin),
  ];
}
